import React from 'react'
import { CModal, CModalBody, CModalFooter, CButton } from '@coreui/react'

export default function RejectInformationModal({ visible, setVisible, reason, setSelectedDocForRejectInfo }) {
   console.log('reason', reason)
   return (
      <CModal visible={visible} onClose={() => {
         setVisible(false)
         setSelectedDocForRejectInfo(null)

      }}
      >
         <CModalBody>
            <h5>Причина відмови</h5>
            <p style={{ whiteSpace: 'pre-wrap' }}>{reason || 'Причина відсутня'}</p>
         </CModalBody>
         <CModalFooter>
            <CButton color="secondary" onClick={() => setVisible(false)}>
               Закрити
            </CButton>
         </CModalFooter>
      </CModal>
   )
}
